import { useAssistantChatStore } from "@/assistents/stores/assistantChat";

const AssistentChatResolver = async (to, from, next) => {
    try {
        const store = useAssistantChatStore();
        const active = await store.loadChatInfo(to.params.key);
        if (!active) return next({ name: "403" });
        return next();
    } catch (err) {
        console.error("AssistentChatResolver error:", err);
        return next({ name: "403" });
    }
}

export default AssistentChatResolver;
